<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :actions="actions"
    :title="$t('model.passenger')"
    resource="passengers"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend } from '../admin_grapes/passengers.js';

@Component
export default class Passengers extends Vue {
  @Prop(String) type;

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'email_cont',
      'phone_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'email',
      'first_name',
      'last_name',
      'phone_country_code',
      'phone',
      'passenger_type',
      'birthday',
      'user',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }
}

export const route = [
  {
    path: '/passengers',
    name: 'passengers.index',
    component: Passengers,
    props: {
      type: 'index',
    }
  },
  {
    path: '/passengers/:id',
    name: 'passengers.show',
    component: Passengers,
    props: {
      type: 'show',
    }
  },
]
</script>
